<template>
  <div class="min-h-screen bg-[#FAFAF8] px-6 py-12">
    <div
      class="max-w-4xl mx-auto bg-white rounded-xl shadow-sm p-8 border border-gray-100 space-y-6"
    >
      <h1 class="text-3xl font-extrabold text-[#0B2447]">
        Conditions Générales de Vente
      </h1>

      <section class="space-y-3">
        <h2 class="text-lg font-bold text-orange-600">
          1. Abonnements et Tarifs
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          L'accès à Giraaf Workflow peut faire l'objet d'abonnements payants
          selon la formule choisie. Les tarifs en vigueur sont ceux indiqués
          lors de la souscription de l'offre.
        </p>
      </section>

      <section class="space-y-3">
        <h2 class="text-lg font-bold text-orange-600">
          2. Paiement et Facturation
        </h2>
        <p class="text-gray-600 text-sm leading-relaxed">
          Les paiements s'effectuent par prélèvement bancaire ou carte bancaire
          de manière sécurisée. Toute période entamée est due.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CgvView'
}
</script>
